var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconesAreas03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 122.5 143",
    style: {
      enableBackground: "new 0 0 122.5 143"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2B9BC6;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M118.4,117.1c-2.5-0.2-4.4,1.6-4.7,4.3c-0.9,8.6-5.6,12.7-14.2,12.7c-25.5,0-50.9,0-76.4,0 c-9.2,0-14.3-5-14.3-14.2c0-32.3,0-64.6,0-96.9c0-9.2,5.1-14.2,14.2-14.2c25.5,0,50.9,0,76.4,0c9.2,0,14.2,5.1,14.2,14.2 c0,14.4,0,28.7,0,43.1l0,25.1c0,0.2,0,0.5,0,0.7c0,0.6,0,1.2,0,1.7c0.3,2.4,2.1,4,4.4,4c2.3,0,4.1-1.7,4.3-4.1c0-0.4,0-0.7,0-1.1 l0-0.4l0-19.6c0-16.7,0-33.4,0-50c0-13.1-9.2-22.3-22.3-22.3C87.3,0,74.4,0,61.5,0C48.5,0,35.4,0,22.4,0C9.2,0,0,9.2,0,22.3 C0,34.2,0,46.1,0,58l0,13.4c0,5.1,0,10.2,0,15.4c0,11.4,0,23.3,0,34.9c0.1,11.4,9.4,21,20.3,21.1c27.1,0.2,54.6,0.2,81.8,0 c5.2,0,10.4-2.4,14.3-6.4c4-4.1,6.2-9.4,6-14.7C122.4,119.1,120.8,117.3,118.4,117.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93.4,23.7c-10.6,0-21.4,0-32.1,0s-21.4,0-32.1,0c-3.8,0-5.3,1.5-5.3,5.4c0,6.9,0,13.8,0,20.7 c0,4.2,1.4,5.6,5.6,5.7c7.5,0,14.9,0,22.4,0l9.1,0l9.2,0c7.6,0,15.2,0,22.9,0c4.2,0,5.6-1.4,5.6-5.7c0-6.9,0-13.8,0-20.7 C98.6,25.2,97.1,23.7,93.4,23.7z M89.6,46.5H32.9V32.6h56.7V46.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.8,104.5L95.8,104.5c0-1,0-2,0-3c0-2.3,0-4.6,0-6.9c0-2.7-1.8-4.7-4.2-4.8c0,0-0.1,0-0.1,0 c-1.1,0-2.2,0.4-3,1.2c-0.9,0.8-1.4,2-1.4,3.2c-0.1,7.1-0.1,14.1,0,20.6c0,2.5,1.8,4.2,4.4,4.3c0,0,0,0,0,0c2.6,0,4.3-1.8,4.4-4.5 c0.1-2.3,0-4.7,0-7C95.8,106.6,95.8,105.6,95.8,104.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.2,76.4c1.5,0.1,3.1,0.1,4.7,0c2.2-0.2,4-1.9,4.1-4.1c0.1-2.3-1.5-4.3-3.8-4.6c-0.5-0.1-1.1-0.1-1.7,0 c-0.3,0-0.6,0-0.9,0h-1.3v-0.1c0,0-0.1,0-0.1,0c-0.3,0-0.5,0-0.8,0c-2.7,0.1-4.6,1.9-4.6,4.4C54.6,74.5,56.5,76.3,59.2,76.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.3,89.1c0,0-0.1,0-0.2,0c-0.2,0-0.4,0-0.6,0c-0.2,0-0.4,0-0.6,0c-0.3,0-0.5,0-0.8,0c-2.5,0.1-4.3,1.7-4.4,4 c-0.2,2.4,1.5,4.4,4,4.7c0.6,0.1,1.3,0.1,2,0.1l0.6,0c0,0,0,0,0,0c2.6,0,4.6-0.6,5.6-1.7c0.7-0.7,1-1.7,1-2.9 C67.9,91.3,67,89.1,61.3,89.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.8,69.3c-1.1-1.1-3-1.7-5.7-1.7c0,0,0,0,0,0c-5.8,0-6.6,2.2-6.6,4.3c0,1.3,0.3,2.3,1,3c1,1,2.9,1.5,5.7,1.5 c5.9,0,6.6-2.4,6.7-4.3C37.8,71,37.5,70,36.8,69.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30,98c0.1,0,0.1,0,0.2,0l0.8,0c0.3,0,0.6,0,0.8,0c0.6,0,1.1,0,1.6,0c2.6-0.3,4.5-2.2,4.4-4.6 c-0.1-2.4-1.9-4-4.6-4.1c-0.8,0-1.6,0-2.3,0c-0.8,0-1.5,0-2.2,0c-2.4,0.1-4.1,1.6-4.3,3.9c-0.2,2.3,1.3,4.3,3.6,4.8 C28.7,97.9,29.3,97.9,30,98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.3,67.7c-0.5-0.1-1.1-0.1-1.7,0c-0.3,0-0.6,0-0.9,0h-1.3v-0.1c-0.1,0-0.2,0-0.3,0c-0.3,0-0.6,0-0.9,0 c-2.5,0.2-4.4,2-4.4,4.4c0,2.5,1.9,4.3,4.5,4.4c1.4,0.1,3,0.1,4.7,0c2.3-0.2,4-1.8,4.1-4.1C98.2,70,96.6,68.1,94.3,67.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.8,110.5c-0.8-0.1-1.7-0.1-2.5-0.1c-0.9,0-1.7,0-2.6,0.1c-2.4,0.2-4.1,2-4.1,4.4c0,2.4,1.8,4.1,4.4,4.3 c0.5,0,0.9,0,1.4,0c0.2,0,0.5,0,0.7,0h0c0.3,0,0.6,0,0.9,0c0.6,0,1.1,0,1.6,0c2.5-0.2,4.2-1.8,4.3-4.1 C68,112.7,66.3,110.8,63.8,110.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.1,119.3c0.4,0,0.9,0,1.3,0l0.6,0c0.3,0,0.5,0,0.8,0c0.5,0,1,0,1.4,0c2.7-0.2,4.4-1.8,4.5-4.2 c0.1-2.5-1.8-4.3-4.5-4.5c-0.7-0.1-1.4-0.1-2.2-0.1c-0.7,0-1.4,0-2.2,0.1c-2.8,0.2-4.5,1.9-4.5,4.5 C24.5,117.5,26.3,119.1,29.1,119.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconesAreas03);
export default __webpack_public_path__ + "static/media/IconesAreas03.636778ca9d2d335a451c6cbc5e177641.svg";
export { ForwardRef as ReactComponent };